import { render, staticRenderFns } from "./VerveIcon.vue?vue&type=template&id=18bd8db7&scoped=true"
import script from "./VerveIcon.vue?vue&type=script&lang=js"
export * from "./VerveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd8db7",
  null
  
)

export default component.exports